<template>
  <ol
    class="breadcrumb"
    :class="[
      { 'breadcrumb--step1': step === 1 },
      { 'breadcrumb--step2': step === 2 },
      { 'breadcrumb--step3': step === 3 },
      { 'breadcrumb--success': type === 'success' },
      { 'breadcrumb--error': type === 'error' },
      { 'breadcrumb--warning': type === 'warning' }
    ]"
  >
    <li class="breadcrumb__item breadcrumb__item--1">
      <div class="breadcrumb__item__info">
        <span class="breadcrumb__item__number">1</span>
        <span v-html="$t(`${namespace}.importSpreadsheet`)" class="breadcrumb__item__text" />
      </div>
    </li>

    <li v-if="type === 'error'" class="breadcrumb__item--error">
      <v-icon color="gray-3">close</v-icon>
    </li>

    <li class="breadcrumb__item breadcrumb__item--2">
      <div class="breadcrumb__item__info">
        <span class="breadcrumb__item__number">2</span>
        <span v-html="$t(`${namespace}.resolvingConflicts`)" class="breadcrumb__item__text" />
      </div>
    </li>

    <li class="breadcrumb__item breadcrumb__item--3">
      <div class="breadcrumb__item__info">
        <span class="breadcrumb__item__number">3</span>
        <span v-html="$t(`${namespace}.conclusion`)" class="breadcrumb__item__text" />
      </div>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    step: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.breadcrumb'
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
